var React = require('react');

function Cloud1 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M47.3594 88.55C47.3594 88.55 46.7094 67.84 67.5894 58.78C88.4694 49.72 108.039 65.09 108.039 65.09C108.039 65.09 95.5794 31.59 121.309 12.66C147.039 -6.26999 186.679 -7.07999 206.909 31.92C206.909 31.92 229.399 -9.17999 278.919 22.21C278.919 22.21 314.199 47.45 291.059 93.41C291.059 93.41 311.769 91.14 318.729 105.71C325.689 120.27 320.509 145.84 295.749 145.84H31.4994C31.4994 145.84 2.36938 146 0.109385 115.26C-2.15062 84.52 31.1794 78.03 47.3594 88.55Z","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"321.55","height":"145.83","fill":"white"})))]);
}

Cloud1.defaultProps = {"width":"322","height":"146","viewBox":"0 0 322 146","fill":"none"};

module.exports = Cloud1;

Cloud1.default = Cloud1;
